import React from 'react';

import { Loader } from 'components';
import { TableBody, TableCell, TableRow, Typography } from '@mui/material';
import { texts } from 'utils/languages/fr';

const EmptyTableBody = ({ colSpan, loading = false, message = texts.EMPTY_TABLE_DEFAULT }) => {
    return (
        <TableBody>
            <TableRow>
                <TableCell colSpan={colSpan}>
                    <Loader marginTop={0} loading={loading}>
                        <Typography variant="h6" align="left" gutterBottom>
                            {message}
                        </Typography>
                    </Loader>
                </TableCell>
            </TableRow>
        </TableBody>
    );
};

export default EmptyTableBody;
